module.exports = __webpack_public_path__ + "img/main3.ef546923.jpg";